/**
 * Admin Team Management — `/admin/teams`
 *
 * Search/list teams with infinite scroll, view usage logs, add credits
 * (with optional Pro flip), and refresh Stripe subscription state. Backed
 * by the `adminTeams` tRPC router (extracted from the legacy catch-all
 * `admin` router for 1:1 panel↔router parity per `kit-vidmax-admin/skill.md`).
 */
import { createFileRoute } from "@tanstack/react-router"
import { TeamList } from "~/components/Admin/AdminTeamList"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

import type { ReactElement } from "react"
function AdminTeams() {
  return (
    <>
      <CustomHead />

      <div>
        <TeamList />
      </div>
    </>
  )
}

function AdminTeamsWrapper() {
  return (
    <SuperAdminLayout>
      <AdminTeams />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/teams")({
  component: AdminTeamsWrapper,
})
